/**
 * @desc 获取商户支付宝实名认证结果
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** merchantNo */
  merchantNo: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/merchant/alipayVerifiedResult',
    params,
    method: 'get',
  })
}
